import { mutation, query } from "@core/helpers/graphql";
import { GET_DEBT, GET_DEPUTATIONS, GET_SHIPPING_METHODS, GET_SHIPPING_METHODS_AND_PAYMENT_METHODS_AND_DEPUTATIONS, GET_USER_ADDRESSES_AND_SHIPPING_METHODS_AND_PAYMENT_METHODS, GET_USER_ADDRESSES_AND_SHIPPING_METHODS_AND_PAYMENT_METHODS_AND_DEPUTATIONS, GET_USER_PAYMENT_METHODS, GET_USER_WALLET, GET_USER_WALLET_TRANSACTIONS } from "./_queries";
import { CHARGE_WALLET, CHECK_DISCOUNT_CODE, CLOSE_CART, PAY_DEBT, SET_CART_FLAGS } from "./_mutations";

export const get_checkout_details_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_USER_ADDRESSES_AND_SHIPPING_METHODS_AND_PAYMENT_METHODS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_checkout_details_with_deputations_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_SHIPPING_METHODS_AND_PAYMENT_METHODS_AND_DEPUTATIONS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_shipping_methods_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_SHIPPING_METHODS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_deputations_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_DEPUTATIONS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const apply_discount_code_mutation = async (variables, options = {}) => {
  const { gql } = options
  const result = await mutation(gql || CHECK_DISCOUNT_CODE, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}


export const close_cart_mutation = async (variables, options = {}) => {
  const { gql } = options
  const result = await mutation(gql || CLOSE_CART, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_debt_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_DEBT, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const pay_debt_mutation = async (variables, options = {}) => {
  const { gql } = options
  const result = await mutation(gql || PAY_DEBT, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}


export const get_user_wallet_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_USER_WALLET, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const charge_wallet_mutation = async (variables, options = {}) => {
  const { gql } = options
  const result = await mutation(gql || CHARGE_WALLET, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const set_cart_flags_mutation = async (variables, options = {}) => {
  const { gql } = options
  const result = await mutation(gql || SET_CART_FLAGS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_user_wallet_transactions_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_USER_WALLET_TRANSACTIONS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_user_payment_methods_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_USER_PAYMENT_METHODS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}
